import { Grid, makeStyles, Typography } from '@material-ui/core';
import CommentIcon from 'assets/discovery/comment-icon.png';
import LikeIcon from 'assets/discovery/like-icon.png';
import { useEffect, useState } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { getYtHandlerData } from 'api_handlers/competitor';

export default function CreatorDetailedInsightsCard({ keyword, startDate, endDate, searchKeyword }) {
  const classes = useStyles();
  const [userData, setUserData] = useState([]);
  let [pageNumber, setPageNumber] = useState(1);
  const [isNext,setIsNext]=useState(true)
  const queryParameters = new URLSearchParams(window.location.search);
  const [type] = useState(queryParameters.get('creator_type'));


  useEffect(() => {
    const fetchHandlerData = async () => {
      try {
        const resp = await getYtHandlerData(keyword, type, pageNumber, startDate, endDate, searchKeyword); // Wait for the response
        const mergedData = [...userData, ...resp.results];
        if(resp.next){
          setIsNext(true)
        }else{
          setIsNext(false)
        }
        setUserData(mergedData);
      } catch (error) {
        console.error('Error fetching creator posts:', error);
      }
    }

    fetchHandlerData();
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pageNumber]);

  function fetchMoreData() {
    setPageNumber((prevPageNumber) => prevPageNumber + 1);
  }

  function countertostring(counter) {
    counter = parseFloat(counter);
    if (counter >= 1000 && counter < 999999) {
      return (
        parseFloat(counter / 1000.0)
          .toFixed(2)
          .toString() + 'K'
      );
    } else if (counter > 999999) {
      return (
        parseFloat(counter / 1000000.0)
          .toFixed(2)
          .toString() + 'M'
      );
    } else {
      return counter.toString();
    }
  }

  return (
    <InfiniteScroll
      dataLength={userData.length}
      next={fetchMoreData}
      hasMore={isNext}
      loader={<h4>Loading...</h4>}
        endMessage={
          <p style={{ textAlign: "center" }}>
              <b>No more posts are found.</b>
            </p>
          // isPlanActive ? (
            
          // ) : (
          //   ""
          // )
        }
    >
      <Grid container>
        {userData.length > 0
          ? userData.map((data, i) => (
              <Grid item md={3}>
                <Grid container justifyContent="space-between">
                  <Grid item className={classes.card} style={{ height: '100%', width: '100%' }}>
                    <Grid
                      container
                      direction="column"
                      alignItems="center"
                      justifyContent="space-between"
                    >
                      <Grid item style={{ width: '90%' }} md={12}>
                        <Typography
                          className={classes.instaHandler}
                          onClick={() => {
                            window.open(`https://www.youtube.com/${data.creator}/`, '_blank');
                          }}
                        >
                          {data.creator}
                        </Typography>
                      </Grid>
                      <Grid
                        item
                        md={11}
                        onClick={() => {
                          window.open(
                            `https://www.youtube.com/watch?v=${data.video_id}/`,
                            '_blank',
                          );
                        }}
                      >
                        <img src={data.yt_thumnail_url} className={classes.image} alt="icon" />
                      </Grid>
                      <Grid item md={11}>
                        {data.description && data.description.length < 170 ? (
                          <Typography style={{ height: 100 }} variant="body2">
                            {data.title}
                          </Typography>
                        ) : (
                          <Typography style={{ height: 100, overflowY: 'scroll' }} variant="body2">
                            {data.description}
                          </Typography>
                        )}
                      </Grid>
                      <Grid item md={12}>
                        <Grid container spacing={3} style={{ marginTop: 10 }}>
                          <Grid item>
                            <Grid container alignItems="center">
                              <Grid item>
                                <img src={LikeIcon} alt="likeicon" className={classes.icon} />
                              </Grid>
                              <Grid item>
                                <Typography className={classes.data} variant="h5">
                                  {countertostring(data.likes_count)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                          <Grid item>
                            <Grid container alignItems="center">
                              <Grid item>
                                <img src={CommentIcon} alt="commenticon" className={classes.icon} />
                              </Grid>
                              <Grid item>
                                <Typography className={classes.data} variant="h5">
                                  {countertostring(data.comments_count)}
                                </Typography>
                              </Grid>
                            </Grid>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
            ))
          : ''}
      </Grid>
    </InfiniteScroll>
  );
}

const useStyles = makeStyles(() => ({
  card: {
    background: 'linear-gradient(135.2deg, #EEEFF8 10.88%, rgba(251, 252, 255, 0.76) 100%)',
    boxShadow:
      '-5px 5px 10px rgba(215, 216, 220, 0.2), 5px -5px 10px rgba(215, 216, 220, 0.2), -5px -5px 10px rgba(255, 255, 255, 0.9), 5px 5px 13px rgba(215, 216, 220, 0.9), inset 1px 1px 2px rgba(255, 255, 255, 0.3), inset -1px -1px 2px rgba(215, 216, 220, 0.5)',
    borderRadius: 20,
    padding: 20,
    maxWidth: 300,
    marginLeft: 20,
    marginTop: 50,
  },
  instaHandler: {
    fontSize: 18,
    textAlign: 'start',
    cursor: 'pointer',
    fontWeight: 600,
  },
  image: {
    height: 220,
    width: 220,
    borderRadius: 20,
    marginTop: 10,
    textAlign: 'center',
    cursor: 'pointer',
  },
  icon: {
    height: 20,
    width: 20,
    marginTop: 9,
  },
  data: {
    marginLeft: 3,
  },
}));
